import { REGISTRO_LOGOUT } from "../../ActionTypes";

export const logoutRegistro = () => (dispatch) => {
  dispatch({ type: REGISTRO_LOGOUT });
};
